import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Text, Box, Group, Drawer, Button, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { useLoginContextSU } from "../../context/loginContextSU";
import { BE_API_DELETE, utils } from "../../utils/globalVariables";
import SUDataUserData from "./SUDataUserData";
import ModalResponse from "../../components/general/ModalResponse";

const SUDataUserDelete = ({
    stateShow,
    fnShow,
    stateData,
    fnSuccessDelete,
}) => {

    const mountedRef = React.useRef(true);
    const { loginContextSU, handleSetLoginContextSU } = useLoginContextSU();

    const notificationId = React.useRef({
        errorDeleteData: 'SUDataUserDelete-1',
        successDeleteData: 'SUDataUserDelete-2',
    })

    const [data, setData] = React.useState({
        deleteLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        },
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const deleteData = () => {
        setData(d => ({ ...d, deleteLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContextSU.syswebapp);
        formDT.append('id', stateData.user_id);

        axios({
            method: 'post',
            url: BE_API_DELETE + '/delete_user',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, deleteLoading: false }));

            if (response.data.flag_status === 'isset') {

                fnSuccessDelete();

                notifications.show({
                    id: notificationId.current.successDeleteData,
                    title: utils.notification.success.caption,
                    message: 'Berhasil Delete Data.',
                    color: utils.notification.success.color,
                    icon: utils.notification.success.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorDeleteData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'cannot-be-deleted') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak dapat dihapus karena telah digunakan pada sistem (Project).',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContextSU(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContextSU(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, deleteLoading: false }));

            notifications.show({
                id: notificationId.current.errorDeleteData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: false,
            })
        })
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Delete User</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>
                    <Text
                        size="sm"
                        mb='2rem'
                    >
                        <SUDataUserData
                            stateData={stateData}
                        />
                    </Text>

                    <Group position="apart" noWrap spacing='xs' my='xl'>
                        <Button
                            fullWidth
                            variant="light"
                            color='red'
                            loading={data.deleteLoading}
                            onClick={deleteData}
                        >
                            Delete
                        </Button>
                    </Group>
                </Box>
            </Drawer>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}
                stateOverlayZIndex={201}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default SUDataUserDelete;